import api from './api';

/**
 * Fetch all users (admin endpoint)
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.per_page - Items per page
 * @param {string} params.search - Search term
 */
export const fetchUsers = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.per_page) queryParams.append('per_page', params.per_page);
  if (params.search) queryParams.append('search', params.search);
  
  const endpoint = `/admin/users${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await api.get(endpoint);
  return response.data;
};

/**
 * Fetch a single user by ID
 * @param {number} id - User ID
 */
export const fetchUser = async (id) => {
  const response = await api.get(`/admin/users/${id}`);
  return response.data;
};

/**
 * Update user status
 * @param {number} id - User ID
 * @param {string} status - New status ('active' or 'inactive')
 */
export const updateUserStatus = async (id, status) => {
  const response = await api.put(`/admin/users/${id}/status`, { status });
  return response.data;
};

/**
 * Update user role and/or status
 * @param {number} id - User ID
 * @param {Object} data - { role?: 'user'|'admin', status?: 'active'|'inactive' }
 */
export const updateUser = async (id, data) => {
  const response = await api.put(`/admin/users/${id}`, data);
  return response.data;
};
